import { render, staticRenderFns } from "./ShopNewDoctorCategoryTable.vue?vue&type=template&id=0e3fc283&scoped=true&"
import script from "./ShopNewDoctorCategoryTable.vue?vue&type=script&lang=js&"
export * from "./ShopNewDoctorCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopNewDoctorCategoryTable.vue?vue&type=style&index=0&id=0e3fc283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3fc283",
  null
  
)

export default component.exports